export const CONST_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  NOT_ORDER: false,
  HAVE_ORDER: true,
};
